import { useVisible } from '~/hooks/useVisible';

export interface UseDialogStateOutput {
  close: () => void;
  open: () => void;
  toggle: () => void;
  isOpen: boolean;
}

export const useDialogState = (): UseDialogStateOutput => {
  const { hide, show, toggle, isVisible } = useVisible();

  return {
    close: hide,
    open: show,
    toggle,
    isOpen: isVisible,
  };
};
